import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _b2727fda = () => interopDefault(import('../pages/constants.js' /* webpackChunkName: "pages/constants" */))
const _378bab2d = () => interopDefault(import('../pages/docSearch.vue' /* webpackChunkName: "pages/docSearch" */))
const _d085590c = () => interopDefault(import('../pages/test.js' /* webpackChunkName: "pages/test" */))
const _1655a6b6 = () => interopDefault(import('../pages/demoList/service.js' /* webpackChunkName: "pages/demoList/service" */))
const _63f663ee = () => interopDefault(import('../pages/webDemoCenter/_.vue' /* webpackChunkName: "pages/webDemoCenter/_" */))
const _ae7b9a22 = () => interopDefault(import('../pages/sdkDemoCenter/_.vue' /* webpackChunkName: "pages/sdkDemoCenter/_" */))
const _6a115474 = () => interopDefault(import('../pages/news/_.vue' /* webpackChunkName: "pages/news/_" */))
const _522f9414 = () => interopDefault(import('../pages/demoList/_.vue' /* webpackChunkName: "pages/demoList/_" */))
const _266b87e8 = () => interopDefault(import('../pages/_.vue' /* webpackChunkName: "pages/_" */))

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/constants",
    component: _b2727fda,
    name: "constants"
  }, {
    path: "/docSearch",
    component: _378bab2d,
    name: "docSearch"
  }, {
    path: "/test",
    component: _d085590c,
    name: "test"
  }, {
    path: "/demoList/service",
    component: _1655a6b6,
    name: "demoList-service"
  }, {
    path: "/webDemoCenter/*",
    component: _63f663ee,
    name: "webDemoCenter-all"
  }, {
    path: "/sdkDemoCenter/*",
    component: _ae7b9a22,
    name: "sdkDemoCenter-all"
  }, {
    path: "/news/*",
    component: _6a115474,
    name: "news-all"
  }, {
    path: "/demoList/*",
    component: _522f9414,
    name: "demoList-all"
  }, {
    path: "/*",
    component: _266b87e8,
    name: "all"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
